/**
 *
 * Asynchronously loads the component for ActionAlerts
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
